import { CalendarDisplaySettings } from '@pages/Calendar/ui/CalendarDisplaySettings';

import { useCalendarHeaderSettings } from '../hooks';

import '../styles/CalendarHeaderSettings.scss';

export const CalendarHeaderSettings = () => {
  const {
    intervalHeightSize,
    intervalHeightSizeOptions,
    gridStepMinutes,
    gridStepMinuteOptions,
    timeFormat,
    timeFormatOptions,
    isTimeFormatLoading,
    changeTimeFormatHandler,
    preferredMaxColumns,
    preferredMaxColumnOptions,
    gridStepMinutesChangeHandler,
    intervalHeightSizeChangeHandler,
    preferredMaxColumnsChangeHandler,
    previewFields,
    previewFieldsChangeHandler,
  } = useCalendarHeaderSettings();

  return (
    <div className="CalendarHeaderSettings">
      <CalendarDisplaySettings
        tooltipTitle="Настройки журнала записей"
        testId="calendar-header-settings"
        intervalHeightSize={intervalHeightSize}
        intervalHeightSizeOptions={intervalHeightSizeOptions}
        gridStepMinutes={gridStepMinutes}
        gridStepMinuteOptions={gridStepMinuteOptions}
        timeFormat={timeFormat}
        timeFormatOptions={timeFormatOptions}
        isTimeFormatLoading={isTimeFormatLoading}
        onTimeFormatChange={changeTimeFormatHandler}
        preferredMaxColumns={preferredMaxColumns}
        preferredMaxColumnOptions={preferredMaxColumnOptions}
        onIntervalHeightSizeChange={intervalHeightSizeChangeHandler}
        onGridStepMinutesChange={gridStepMinutesChangeHandler}
        onPreferredMaxColumnsChange={preferredMaxColumnsChangeHandler}
        previewFields={previewFields}
        onPreviewFieldsChange={previewFieldsChangeHandler}
      />
    </div>
  );
};
